const APISiteRequest = {};

APISiteRequest["getAllSites"] = async (accessToken) => {
	try {
		const response = await fetch('/api/sites', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["getAllSitesByProvinceId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/sites/province/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["getSiteById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/sites/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["getAllSiteWorkingGroupsBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/site-working-group/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["getAllLocalStudyTeamsBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/local-study-team/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["getAllProspectiveBuyersBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/mcs/prospective-buyers/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["getProspectiveBuyerById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/mcs/prospective-buyers/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["getProspectiveBuyersBySiteIdAndCropId"] = async (accessToken, sid, cid) => {
	try {
		const response = await fetch('/api/mcs/prospective-buyers/site/' + sid + '/crop/' + cid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["addSite"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/sites', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["addProspectiveBuyerBySiteId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/mcs/prospective-buyers', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["addSiteWorkingGroupBySiteId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/site-working-group/site/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["addLocalStudyTeamBySiteId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/local-study-team/site/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["editSite"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/sites/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["editSiteWorkingGroupBySiteId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/site-working-group/site/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["editLocalStudyTeamBySiteId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/local-study-team/site/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["editProspectiveBuyerById"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/mcs/prospective-buyers/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISiteRequest["deleteSite"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/sites/' + id, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify({name: ''})
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		console.log(body);
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APISiteRequest
